import { graphql } from "@/lib/gql/__generated__/gql";

export const OptionCreate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation OptionCreate($input: OptionInput!) {
		optionCreate(input: $input) {
			userErrors
			option {
				id
				hotelID
				optionID
				inSale
				isNotDiscountTarget
				maxStockNum
				soldNumTotal
				maxDailyStockNum
				optionType
				billingTypeTerm
				billingTypeTarget
				price {
					currencyType
					amount
				}
				name
				description
				isNextMorning
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				saleTypeForPlan
				saleTypeForTerm
				saleStart
				saleEnd
				stayableStart
				stayableEnd
				stayableDayOfTheWeek
				isHolidayStayable
				saleStartBeforeDate
				requiredPrepMillisecond
				maxBuyableNumPerTarget
				minimumBuyableNumPerTarget
				useAsSubOption
				multiSubOptionSelectable
				subOptions {
					subOptionID
					name
					startAt
					endAt
					isNextMorning
					memo
					maxDailyStockNum
					isShowTimeSchedule
				}
			}
		}
	}
`);
